'use strict'

import ApiClient from './ApiClient'

export default class InputProxySettingsRepository {
  /**
   * 修正サービスの設定を取得
   * @returns {*}
   */
  get () {
    return ApiClient().get(`/input-proxy-settings`)
  }

  /**
   *  修正サービスの設定を更新
   * @param params sendData
   * @returns {*}
   */
  put (params) {
    return ApiClient().put(`/input-proxy-settings`, params)
  }
}



// WEBPACK FOOTER //
// ./src/repositories/InputProxySettingsRepository.js